import { useMelwaysInfo } from '@seek/melways-react';

export const useLearnMoreLink = () => {
  const { country, language } = useMelwaysInfo();
  switch (country) {
    case 'au':
      return 'https://help.au.seek.com/s/article/Why-am-I-being-asked-to-verify-my-right-to-work-when-applying-for-a-job-AU';
    case 'nz':
      return 'https://help.nz.seek.com/s/article/Why-am-I-being-asked-to-verify-my-right-to-work-when-applying-for-a-job-NZ';
    case 'my':
      return 'https://help.my.jobstreet.com/article/Why-am-I-being-asked-to-verify-my-right-to-work-when-applying-for-a-job-MY';
    case 'sg':
      return 'https://help.sg.jobstreet.com/s/article/Why-am-I-being-asked-to-verify-my-right-to-work-when-applying-for-a-job-SG';
    case 'ph':
      return 'https://help.ph.jobstreet.com/s/article/Why-am-I-being-asked-to-verify-my-right-to-work-when-applying-for-a-job-PH';
    case 'id':
      return language === 'id'
        ? 'https://help.id.jobstreet.com/id/s/article/Why-am-I-being-asked-to-verify-my-right-to-work-when-applying-for-a-job-ID?language=in'
        : 'https://help.id.jobstreet.com/id/s/article/Why-am-I-being-asked-to-verify-my-right-to-work-when-applying-for-a-job-ID?language=en_US';
    case 'hk':
      return 'https://help.hk.jobsdb.com/s/article/Why-am-I-being-asked-to-verify-my-right-to-work-when-applying-for-a-job-HK';
    case 'th':
      return language === 'th'
        ? 'https://help.th.jobsdb.com/th/s/article/Why-am-I-being-asked-to-verify-my-right-to-work-when-applying-for-a-job-TH?language=th'
        : 'https://help.th.jobsdb.com/th/s/article/Why-am-I-being-asked-to-verify-my-right-to-work-when-applying-for-a-job-TH?language=en_US';
    default:
      return 'https://help.au.seek.com/s/article/Why-am-I-being-asked-to-verify-my-right-to-work-when-applying-for-a-job-AU';
  }
};
